import { Modal } from "./Modal";

interface ImagePreviewModalProps {
  open: boolean;
  onClose: () => void;
  url?: string | null;
  fileName?: string;
  isVideo?: boolean;
}

// Full-size preview popup for a clicked thumbnail — used by the Gallery
// screen (images and videos) and Product's image thumbnails (images only).
export const ImagePreviewModal = ({ open, onClose, url, fileName, isVideo }: ImagePreviewModalProps) => (
  <Modal open={open} title={fileName ?? "Preview"} onClose={onClose} xwide>
    {!url ? null : isVideo ? (
      <video
        src={url}
        controls
        autoPlay
        style={{ width: "100%", maxHeight: "75vh", display: "block", borderRadius: "var(--radius-sm)" }}
      />
    ) : (
      <img
        src={url}
        alt={fileName ?? "Preview"}
        style={{ width: "100%", maxHeight: "75vh", objectFit: "contain", display: "block", borderRadius: "var(--radius-sm)" }}
      />
    )}
  </Modal>
);
